// Wizard item for the Set Billing Period action (CD-5294): identifies the invoice by its
// natural key and edits only the override. Empty override = remove it.
export default class TpPlatformInvoiceBillingPeriodOverrideItem {
  constructor(invoice) {
    this.TpPlatformInvoiceId = invoice ? invoice.TpPlatformInvoiceId : '';
    this.ThirdPartySource = invoice ? invoice.ThirdPartySource : '';
    this.ThirdPartyInvoiceId = invoice ? invoice.ThirdPartyInvoiceId : '';
    this.InvoiceName = invoice ? invoice.InvoiceName : '';
    this.BillingPeriod = invoice ? invoice.BillingPeriod : '';
    this.BillingPeriodOverride = invoice ? invoice.BillingPeriodOverride : '';
  }
}
